function init() {
  const navigation = document.querySelector('.c-featured__navigation');
  const left_arrow = document.querySelector('.c-featured__left_arrow');
  const right_arrow = document.querySelector('.c-featured__right_arrow');
  const dot_dot_dot = document.getElementsByClassName('c-featured__dot');
  const cards = document.getElementsByClassName('c-card');
  const container = document.querySelector('.c-scroller');
  var breakpoints = [];
  var index = 0;



  if (!navigation) {
    return;
  }

  var testimonials = document.querySelectorAll('.c-card');
  Array.prototype.forEach.call(testimonials, function(elements, index) {
      breakpoints.push(elements.id);
  });

  get_scroll_positions();

  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('c-featured__dot')) {
        index = event.target.dataset.index;
        update_dots(event.target.dataset.index);
    }
  }, false);

  left_arrow.addEventListener('click', (e) => {
    e.preventDefault();
    if(index > 0){
      index = index - 1
      update_dots(index);
    }
  });

  right_arrow.addEventListener('click', (e) => {
    e.preventDefault();
    if(index < 2){
      index = index + 1
      update_dots(index);
    }
  });

  function update_dots(add){
    var dots = document.getElementsByClassName('c-featured__dot');
    for (var i = 0; i < dots.length; ++i) {
      var item = dots[i];
      if(item.classList.contains("c-featured__active")){
        item.classList.remove("c-featured__active");
      }
      if(add == i){
        item.classList.add("c-featured__active");
      }
    }



    index = parseInt(add);

  }

  function get_scroll_positions(){
    for (var i = 0; i < cards.length; ++i) {
      var item = cards[i];

    }
  }


}

export default init;
